<template>
  <md-field :class="[
                {'md-error': errors.has('contactCategoryId')},
                {'md-valid': !errors.has('contactCategoryId') && touched.contactCategoryId}]" >
    <md-select
      v-model="contactCategoryId"
      data-vv-name="contactCategoryId"
      v-validate= "modelValidations.contactCategoryId">
      <md-option v-for="item in listData" :value="item.id" :key="item.id">{{item.name}}</md-option>
    </md-select>
    <slide-y-up-transition>
      <div class="vErrorText" v-show="errors.has('contactCategoryId')">【必須】必ず一つ選択してください</div>
    </slide-y-up-transition>
    <slide-y-down-transition>
      <md-icon class="error" v-show="errors.has('contactCategoryId')" style="margin-right:20px">close</md-icon>
    </slide-y-down-transition>
    <slide-y-down-transition>
      <md-icon class="success" v-show="!errors.has('contactCategoryId') && touched.contactCategoryId" style="margin-right:20px">done</md-icon>
    </slide-y-down-transition>
  </md-field>
</template>
<script>
  import NestedValidator from '../../mixins/nested-validator'
  export default {
    inject: ['$validator'],
    mixins: [NestedValidator],
    data() {
      return {
        listData: [],
        modelValidations: {
          contactCategoryId: {
            required: true
          }
        },
        touched: {
          contactCategoryId: false,
        },
      }
    },
    model: {
    },
    props:  ['value','noSelectFlag','touchedFlag'],    // undefinedはfalse扱い
    methods: {
      getCategories () {
        this.axios({
          method  : 'GET',
          url     : this.AdminApiUrl + '/contact_categories/select_list',
          timeout : 10000,
          headers : {'Authorization': this.$Cookies.get('accessToken')}
        }).then(response => {
          this.createList(response.data)
          sessionStorage.setItem('contactCategorySelect', JSON.stringify(response.data))
        })
        .catch(error => {
          this.dangerNotify('お問合せカテゴリリストを取得できませんでした')
        })
      },
      createList (obj) {
        if (this.noSelectFlag) {
          var item = {
            id: '選択しない',
            name: '選択しない',
          }
          this.listData.push(item)
          this.contactCategoryId = '選択しない'
        }
        for (var i in obj) {
          var item = {
            id: obj[i].id,
            name: obj[i].name
          }
          this.listData.push(item)
        }
      },
      setCategory () {
        var contactCategorySelect = sessionStorage.getItem('contactCategorySelect')
        if (contactCategorySelect === null) {
          this.getCategories()
        } else {
          contactCategorySelect = JSON.parse(contactCategorySelect)
          this.createList(contactCategorySelect)
        }
      }
    },
    mounted () {
      this.setCategory()
      this.touched.contactCategoryId = false
    },watch: {
      contactCategoryId(){
        this.touched.contactCategoryId = this.touchedFlag
      },
      '$route.path'(value){
        if (value.match('new')) {
          this.$validator.reset()
          this.touched.contactCategoryId = false 
        }
      }
    },computed: {
      contactCategoryId: {
        get: function() {
          return this.value;
        },
        set: function(newValue) {
          this.$emit('input', newValue)
        }
      }
    }

  }
</script>
<style scoped>
.categorySelect{
  width: 100%;
}
</style>